import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { createSuiTheme, SuiThemeProvider } from '@splashthat/sui';
import './styles.styl';
import StudioHostPreviewer from './StudioHostPreviewer';

const suiTheme = createSuiTheme();
ReactDOM.render(
    <SuiThemeProvider theme={suiTheme}>
        <StudioHostPreviewer />
    </SuiThemeProvider>,
    document.getElementById('root'),
);
